import Vue from 'vue'
import request from "./config/http.js"
import params from "./config/params.js"

const draftsArticleListUrl = '/web/articleManage/queryDraftsArticleList';//草稿箱列表
const deleteDraftsArticleUrl = '/web/articleManage/deleteDraftsArticle';//删除稿件

const queryArticleListUrl = '/web/articleManage/queryArticleList';//我的稿件列表
const articleAddressUrl = '/web/articleManage/updateArticleAddress';//修改邮寄地址
const articleBillUrl = '/web/articleManage/articleBill';//开票
const confirmOrderUrl = '/web/articleManage/confirmOrder';//我的投稿 - 确认订单
const generateOrdersUrl = '/web/articleManage/generateOrders';//生成订单信息
const returnArticleOrderUrl = '/web/articleManage/returnArticleOrder';//退回
const getOrderDetailUrl = '/web/articleManage/getOrderDetail';//我的投稿-付款详情
const cancelOrdersUrl = '/web/articleManage/cancelOrders';//取消订单
const articleNoticeUrl = '/web/articleManage/articleNotice';//通知书



const apis = {

	//草稿箱列表
	draftsArticleList(data) {
		return request({
			url: draftsArticleListUrl,
			method: 'post',
			data:data,
			jsonString:true,
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},

	//删除稿件
	deleteDraftsArticle(data) {
		return request({
			url: deleteDraftsArticleUrl,
			method: 'delete',
			data:data,
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},

	//我的稿件列表
	queryArticleList(data) {
		return request({
			url: queryArticleListUrl,
			method: 'post',
			data:data,
			jsonString:true,
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},

	//修改邮寄地址
	articleAddress(data) {
		return request({
			url: articleAddressUrl,
			method: 'post',
			data:data,
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},

	//开票
	articleBill(data) {
		return request({
			url: articleBillUrl,
			method: 'post',
			data:data,
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	invoiceBill(articleId) {
		return request({
			url: '/web/articleManage/invoiceBill',
			method: 'get',
			params:{
				articleId:articleId
			},
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	retirementOpinion(articleId) {
		return request({
			url: '/web/articleManage/retirementOpinion',
			method: 'get',
			params:{
				articleId:articleId
			},
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},
	//我的投稿 - 确认订单
	confirmOrder(data) {
		return request({
			url: confirmOrderUrl,
			method: 'get',
			params:data,
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},

	//生成订单信息
	generateOrders(data) {
		return request({
			url: generateOrdersUrl,
			method: 'post',
			data:data,
			jsonString:true,
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},

	//退回
	returnArticleOrder(data) {
		return request({
			url: returnArticleOrderUrl,
			method: 'post',
			data:data,
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},

	//我的投稿-订单详情
	getOrderDetail(data) {
		return request({
			url: getOrderDetailUrl,
			method: 'get',
			params:data,
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},

	//取消订单
	cancelOrders(data) {
		return request({
			url: cancelOrdersUrl,
			method: 'put',
			data:data,
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},

	//通知书
	articleNotice(data) {
		return request({
			url: articleNoticeUrl,
			method: 'get',
			params:data,
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},

}


export default apis



// WEBPACK FOOTER //
// ./src/core/api/contributionManagement.serve.js